export default __webpack_public_path__ + "static/media/living_room.70719d78.jpg";